import React, { useEffect, useState } from "react";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import Row from "react-bootstrap/Row";
import { Modal, Col, Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  getPolicyInformationAPI,
  insertConsentAPI,
} from "./ExemptIncomeTaxService/exemptIncomeTaxService";
import SuccessPage from "../Component/Success_page";
import "../ExemptIncomeTax/exemptIncomeTax-styles.css";
import CircularProgress from "@mui/material/CircularProgress";
import CryptoJS from "crypto-js";
import { Typography } from "@material-ui/core";
import successGif from "../../images/successGiff.gif";
import remove from "../../images/remove.png";
import info from "@mui/icons-material/Info";

import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import {
  Grid,
  Backdrop,
  Card,
  CardContent,
  TextField,
  Box,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { notifySuccess, notifyWarning } from "../../util";
import { verifyOtp } from "../QuickTransfer/quickTransferServices/QuickTransferServices";
import { toast } from "react-toastify";
// ./changePay/changePayService/changePayService
import { requestOtpAPI } from "../changePay/changePayService/changePayService";

function getSteps() {
  return ["กรอกข้อมูล", "ยืนยัน OTP", "สำเร็จ"];
}

const ExemptIncomeTax = () => {
  const [dataPolicies, setDataPolicies] = useState([]);
  const [dataRdConsent, setDataRdConsent] = useState([]);
  const [filteredDataRdConsent, setFilteredDataRdConsent] = useState([]);
  const [rdConsent, setRdConsent] = useState([]);
  const [listPolicyNo, setListPolicyNo] = useState([]);
  const [listUndesirePolicyNo, setListUndesirePolicyNo] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [consentOption, setConsentOption] = useState("");
  const steps = getSteps();
  const [insureIdCard, setInsureIdCard] = useState(
    localStorage.getItem("customer_id")
  );
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isAllUnChecked, setIsAllUnChecked] = useState(false);
  const [checkedPolicies, setCheckedPolicies] = useState([]);
  const [checkedUndesirePolicies, setCheckedUndesirePolicies] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const [saveFlag, setSaveFlag] = useState("");
  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };
  const [customerfName, setCustomerfName] = useState(
    localStorage.getItem("first_name")
  );
  const [customerlName, setCustomerlName] = useState(
    localStorage.getItem("last_name")
  );
  const [customerName, setCustomerName] = useState(
    customerfName + " " + customerlName
  );
  const [citizenId, setCitizenId] = useState(
    decryptCardNumber(
      localStorage.getItem("customer_id"),
      process.env.REACT_APP_ENCRYPT_DATA
    )
  );
  const [spinner, setSpinner] = useState(false);
  const [policyDataLoading, setPolicyDataLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpAlertOpen, setOtpAlertOpen] = useState(false);
  const [otpAlertText, setOtpAlertText] = useState("");
  const [otpSentModalOpen, setOtpSentModalOpen] = useState(false);
  const [otpSentMessage, setOtpSentMessage] = useState("");
  const [payload, setPayload] = useState([]);
  const [touchedPolicies, setTouchedPolicies] = useState(new Set());

  // const handleReqOtp = async () => {
  //   const resultReqOtp = await requestOtpAPI();
  //   if (resultReqOtp.status === true) {
  //     notifySuccess(resultReqOtp.meg);
  //   } else {
  //     notifyError(resultReqOtp.meg);
  //   }
  // };

  const notifySuccess = (title) => {
    toast.success(title, {
      position: "top-center",
    });
  };

  const notifyError = (title) => {
    toast.error(title, {
      position: "top-center",
    });
  };

  // ---------- LocalStorage helpers (override map) ----------
  // เก็บเป็น map ราย user: consentChange:<citizenId> => {"00308290":"N","00323467":"Y"}
  const lsKey = () => `consentChange:${citizenId}`;

  const readOverrideMap = () => {
    try {
      return JSON.parse(localStorage.getItem(lsKey()) || "{}");
    } catch {
      return {};
    }
  };

  const writeOverrideMap = (obj) => {
    localStorage.setItem(lsKey(), JSON.stringify(obj));
  };

  // อัปเดต override: ถ้า consentFlagNew เป็น 'Y'/'N' จะ set; ถ้า null/undefined จะลบ key ออก
  const updatePolicyLocalStorage = (policyNo, consentFlagNew) => {
    const map = readOverrideMap();
    if (consentFlagNew === "Y" || consentFlagNew === "N") {
      map[policyNo] = consentFlagNew;
    } else {
      delete map[policyNo];
    }
    writeOverrideMap(map);
  };

  // อ่าน override ของกรมธรรม์เดียว
  const readPolicyFromLS = (policyNo) => {
    const map = readOverrideMap();
    const flag = map?.[policyNo];
    if (!flag) return null;
    return { policyNo, consentFlagNew: flag };
  };

  // ใช้ LS > API เพื่อคำนวณค่าเริ่มต้นของ checkbox (ตอน mount)
  const getDefaultChecked = (item) => {
    const apiChecked = (item.consentFlag) === "Y";
    const map = readOverrideMap();
    const ov = map?.[item.policyNo];
    if (ov === "Y") return true;
    if (ov === "N") return false;
    return apiChecked;
  };

  // รวมค่า override ให้ได้ uiConsent (ค่าที่แสดง)
  const applyLocalOverrides = (items) =>
    items.map((it) => {
      const apiConsent = it.consentFlag ?? "N";
      const ov = readOverrideMap()?.[it.policyNo];
      const uiConsent = ov === "Y" || ov === "N" ? ov : apiConsent;
      return { ...it, apiConsent, uiConsent };
    });

  // seed รายการที่จะส่ง (เฉพาะที่ต่างจาก API)
  const seedChangeListsFromLS = (arr) => {
    const map = readOverrideMap();
    const toY = [];
    const toN = [];
    arr.forEach((item) => {
      const api = item.apiConsent === "Y";
      const ov = map?.[item.policyNo]; // อาจ undefined
      if (!ov) return;
      const now = ov === "Y";
      if (now !== api) {
        (now ? toY : toN).push({
          policyNo: item.policyNo,
          consentFlag: item.consentFlag,
          consentFlagNew: now ? "Y" : "N",
          customerName,
          citizenId,
          baseName: item.baseName || "",
        });
      }
    });
    setListPolicyNo(toY);
    setListUndesirePolicyNo(toN);
  };
  // ---------- End LocalStorage helpers ----------

  useEffect(() => {
    getPolicyInformation();
  }, []);

  const getPolicyInformation = async () => {
    setSpinner(true);
    try {
      const result = await getPolicyInformationAPI(
        decryptCardNumber(insureIdCard, process.env.REACT_APP_ENCRYPT_DATA)
      );

      if (!result?.status) return;
      const activePolicies = (result.data?.policies || []).filter(
        (p) => p?.policyStatus === "มีผลบังคับ"
      );
      setDataPolicies(activePolicies);
      console.log(activePolicies);

      const policyInfoMap = activePolicies.reduce((acc, p) => {
        if (p?.policyNo) {
          acc[p.policyNo.trim()] = {
            baseName: p.baseName || "",
            policyStatus: p.policyStatus || "",
          };
        }
        return acc;
      }, {});

      const rawRdConsent = result.data?.rdConsent || [];
      const rdConsentWithInfo = rawRdConsent.map((item) => {
        const key = (item?.policyNo || "").trim();
        const info = policyInfoMap[key] || {};
        return {
          ...item,
          policyNo: key,
          baseName: info.baseName || "",
          policyStatus: info.policyStatus || "",
        };
      });

      // ★ ผสาน override จาก LS → uiConsent
      const rdConsentUi = applyLocalOverrides(rdConsentWithInfo);
      setDataRdConsent(rdConsentUi);
      console.log(rdConsentUi);
      setRdConsent(rdConsentUi.length > 0 ? rdConsentUi : []);

      const filteredRdConsent = rdConsentUi.filter(
        (x) => x.policyStatus === "มีผลบังคับ"
      );
      console.log(filteredRdConsent);

      setFilteredDataRdConsent(filteredRdConsent);
      // ให้ checkbox แสดงตาม uiConsent (LS มาก่อน)
      setCheckedPolicies(filteredRdConsent.map((it) => it.uiConsent === "Y"));
      // เติม listY/listN ตาม LS (เฉพาะที่ต่างจาก API)
      seedChangeListsFromLS(filteredRdConsent);
    } finally {
      setSpinner(false);
    }
  };

  const handleSelectPolicy = (index) => {
    const newCheckedPolicies = [...checkedPolicies];
    newCheckedPolicies[index] = !newCheckedPolicies[index];
    setCheckedPolicies(newCheckedPolicies);

    if (newCheckedPolicies.every((checked) => !checked)) {
      setIsAllChecked(false);
    }
  };

  // ปรับให้รู้สถานะคลิก (checked/un-checked) เพื่อลด side-effect
  const clickPolicy = (policyNo, isChecked) => {
    setListPolicyNo((prevListPolicyNo) => {
      const exists = prevListPolicyNo.some((po) => po.policyNo === policyNo);
      if (isChecked) {
        if (exists) return prevListPolicyNo; // มีอยู่แล้วไม่ต้องทำซ้ำ
        const newPolicy = filteredDataRdConsent.find(
          (v) => v.policyNo === policyNo
        );
        if (newPolicy) {
          return [
            ...prevListPolicyNo,
            {
              policyNo: policyNo,
              consentFlag: newPolicy.consentFlag,
              consentFlagNew: "Y",
              customerName: customerName,
              citizenId: citizenId,
              baseName: newPolicy.baseName || "",
            },
          ];
        }
      } else {
        // ยกเลิกติ๊ก → เอาออกจาก list Y ถ้ามี
        return prevListPolicyNo.filter((po) => po.policyNo !== policyNo);
      }
      return prevListPolicyNo;
    });
  };

  const saveData = async () => {
    const listToSave = [...listPolicyNo, ...listUndesirePolicyNo];
    console.log(listToSave);
    if (payload.length > 0) {
      setLoading(true);
      try {
        const result = await insertConsentAPI(
          payload,
          decryptCardNumber(insureIdCard, process.env.REACT_APP_ENCRYPT_DATA),
          otp
        );
        console.log(result);

        if (result === "success") {
          setTimeout(() => {
            setActiveStep(2); // Move to success step
            setShowSuccess(true);
            setLoading(false);
            setShowConfirmModal(false);
            // ถ้าต้องการเคลียร์ overrides หลังบันทึกสำเร็จ ให้ปลดคอมเมนต์บรรทัดต่อไป
            // localStorage.removeItem(lsKey());
          }, 1500);
        } else {
          notifyError(result);
          setLoading(false);
        }
      } catch (error) {
        console.error("Failed to insert consent data", error);
      }
    } else {
      setShowModal(true);
    }
  };

  const goToHome = () => {
    if (activeStep === 1) {
      setActiveStep(activeStep - 1);
    } else {
      navigate("/home");
    }
  };

  const handleConfirm = () => {
    if (spinner) {
      setOtpSentMessage("กรุณารอสักครู่ ระบบกำลังโหลดข้อมูล");
      setOtpSentModalOpen(true);
      return;
    }
  
    if (activeStep === 0) {
      if (consentOption) {
        if (consentOption === "all") {
          const payloadToSend = applyBulkConsent("all"); // <-- เก็บ localStorage + สเตตครบ
          // ยิง OTP ได้เลย (ต่อให้ payload ว่างเพราะไม่มีตัวที่เปลี่ยน ก็ถือว่าเลือก all)
          handleReqOtp();
          setActiveStep(1);
          console.log(payloadToSend);
  
        } else if (consentOption === "none") {
          const payloadToSend = applyBulkConsent("none"); // <-- เก็บ localStorage + สเตตครบ
          handleReqOtp();
          setActiveStep(1);
          console.log(payloadToSend);
  
        } else if (consentOption === "some") {
          const payloadToSend = buildSomePayload();
          if (payloadToSend.length > 0) {
            setPayload(payloadToSend);
            handleReqOtp();
            setActiveStep(1);
          } else {
            notifyWarning("กรุณาเลือกอย่างน้อย 1 กรมธรรม์");
          }
        } else {
          setOtpSentMessage("กรุณาเลือกตัวเลือกก่อนดำเนินการต่อ");
          setOtpSentModalOpen(true);
        }
      }
    } else {
      saveData();
    }
  };
  

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const resendOtp = () => {
    handleReqOtp();
  };

  const handleReqOtp = async () => {
    const resultReqOtp = await requestOtpAPI("EXEMPT_INCOME_TAX");
    if (resultReqOtp.status === true) {
      notifySuccess(resultReqOtp.meg);
    } else {
      notifyError(resultReqOtp.meg);
    }
  };

  // useEffect(() => {
  //   if (dataPolicies?.length) {
  //     setCheckedPolicies(dataPolicies.map((p) => p.consentDesireFlag === "Y"));
  //   }
  // }, [dataPolicies]);

  const onTogglePolicy = (isChecked, item, idx) => {
    if (!item) return; // กันเคสผิดพลาด
  
    // 1) อัปเดตสถานะ checkbox แถวนี้
    setCheckedPolicies(prev => {
      const next = [...prev];
      next[idx] = isChecked;
      return next;
    });
  
    // 2) จดว่าแถวนี้ถูก "แตะ" (สำคัญสำหรับโหมด some -> ส่งทุกอันที่ผู้ใช้แตะ)
    setTouchedPolicies(prev => {
      const next = new Set(prev);
      next.add(item.policyNo);   // <= จุดที่ต้องเพิ่ม
      return next;
    });
  
    // 3) Logic เดิมของคุณ (คงไว้ได้)
    const originallyChecked =
      (item.apiConsent ?? item.consentDesireFlag ?? item.consentFlag) === "Y";
  
    if (isChecked) {
      if (!originallyChecked) {
        setListPolicyNo(prev => {
          const others = prev.filter(po => po.policyNo !== item.policyNo);
          return [
            ...others,
            {
              policyNo: item.policyNo,
              consentFlag: item.consentFlag,
              consentFlagNew: "Y",
              customerName,
              citizenId,
              baseName: item.baseName || "",
            },
          ];
        });
        updatePolicyLocalStorage(item.policyNo, "Y");
      } else {
        setListPolicyNo(prev => prev.filter(po => po.policyNo !== item.policyNo));
        updatePolicyLocalStorage(item.policyNo, null);
      }
      setListUndesirePolicyNo(prev => prev.filter(po => po.policyNo !== item.policyNo));
    } else {
      if (originallyChecked) {
        setListUndesirePolicyNo(prev => {
          const others = prev.filter(po => po.policyNo !== item.policyNo);
          return [
            ...others,
            {
              policyNo: item.policyNo,
              consentFlag: item.consentFlag,
              consentFlagNew: "N",
              customerName,
              citizenId,
              baseName: item.baseName || "",
            },
          ];
        });
        updatePolicyLocalStorage(item.policyNo, "N");
      } else {
        setListUndesirePolicyNo(prev => prev.filter(po => po.policyNo !== item.policyNo));
        updatePolicyLocalStorage(item.policyNo, null);
      }
      setListPolicyNo(prev => prev.filter(po => po.policyNo !== item.policyNo));
    }
  };
  

  const applyBulkConsent = (option /* 'all' | 'none' */) => {
    const targetFlagNew = option === "all" ? "Y" : "N";
  
    // อัปเดตติ๊กทุกแถวใน UI ให้ตรงกับ option
    setCheckedPolicies(filteredDataRdConsent.map(() => targetFlagNew === "Y"));
  
    const payloadToSend = filteredDataRdConsent.map((item) => {
      return {
        policyNo: item.policyNo,
        consentFlag: item.consentFlag,      // ค่าจาก API เดิม
        consentFlagNew: targetFlagNew,      // บังคับให้ Y/N ตาม option
        customerName,
        citizenId,
        baseName: item.baseName || "",
      };
    });
  
    // อัปเดต state list ให้สอดคล้อง
    if (targetFlagNew === "Y") {
      setListPolicyNo(payloadToSend);
      setListUndesirePolicyNo([]);
    } else {
      setListPolicyNo([]);
      setListUndesirePolicyNo(payloadToSend);
    }
  
    // เก็บ payload สำหรับยิงตอนยืนยัน OTP
    setPayload(payloadToSend);
  
    return payloadToSend;
  };

  const buildSomePayload = () => {
    if (!Array.isArray(filteredDataRdConsent) || !Array.isArray(checkedPolicies)) return [];
  
    const touched = touchedPolicies; // ใช้ snapshot ปัจจุบัน
    if (!touched || touched.size === 0) return [];
  
    return filteredDataRdConsent
      .map((item, idx) => {
        if (!touched.has(item.policyNo)) return null; // ส่งเฉพาะที่ผู้ใช้แตะ
        const nowChecked = !!checkedPolicies[idx];
        return {
          policyNo: item.policyNo,
          consentFlag: item.consentFlag,          // ค่าเดิม (ไว้ audit)
          consentFlagNew: nowChecked ? "Y" : "N", // ค่าสุดท้ายที่ user เลือก
          customerName,
          citizenId,
          baseName: item.baseName || "",
        };
      })
      .filter(Boolean);
  };
  
  
  

  return (
    <div>
      <Header_Home />
      <div className="top">
        <Header
          style={{ fontSize: "20px" }}
          title="การขอใช้สิทธิยกเว้นภาษีเงินได้"
        />
      </div>
      {spinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </div>
      )}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </div>
      )}
      {!showSuccess ? (
        <div
          className="p-4 frame-other"
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "20px auto 0 auto",
            maxWidth: "1067px",
          }}
        >
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel className="font-size-title">
                  <p style={{ fontSize: "14px" }}>{label}</p>
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          {activeStep === 0 && (
            <div style={{ padding: "0 30px" }}>
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "15px",
                  }}
                >
                  <input
                    type="radio"
                    name="consentOption"
                    value="all"
                    checked={consentOption === "all"}
                    onChange={(e) => setConsentOption(e.target.value)}
                    sx={{
                      color: "#f2654e",
                      "&.Mui-checked": { color: "#f2654e" },
                      transform: "scale(1.2)",
                    }}
                  />
                  มีความประสงค์ใช้สิทธิในกรมธรรม์ทุกฉบับ
                  ทั้งในส่วนของเบี้ยประกันชีวิต และเบี้ยประกันสุขภาพ
                </label>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "15px",
                  }}
                >
                  <input
                    type="radio"
                    name="consentOption"
                    value="none"
                    checked={consentOption === "none"}
                    onChange={(e) => setConsentOption(e.target.value)}
                    sx={{
                      color: "#f2654e",
                      "&.Mui-checked": { color: "#f2654e" },
                      transform: "scale(1.2)",
                    }}
                  />
                  ไม่มีความประสงค์ใช้สิทธิในกรมธรรม์ทุกฉบับ
                </label>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "15px",
                  }}
                >
                  <input
                    type="radio"
                    name="consentOption"
                    value="some"
                    checked={consentOption === "some"}
                    onChange={(e) => {
                      setConsentOption(e.target.value);
                      if (e.target.value === "some") {
                        setPolicyDataLoading(true);
                        setTimeout(() => {
                          setPolicyDataLoading(false);
                        }, 1500);
                      }
                    }}
                    sx={{
                      color: "#f2654e",
                      "&.Mui-checked": { color: "#f2654e" },
                      transform: "scale(1.2)",
                    }}
                  />
                  มีความประสงค์ใช้สิทธิกรมธรรม์บางฉบับ
                </label>
                <br />
                <div className="body-layout-text"></div>
                {consentOption === "some" && (
                  <div style={{ marginLeft: "32px", marginTop: "20px" }}>
                    <div
                      style={{
                        fontWeight: "bold",
                        marginBottom: "10px",
                        color: "#f2654e",
                      }}
                    >
                      {consentOption === "some"
                        ? "เลือกกรมธรรม์ที่ต้องการเพิ่มลงในรายการ"
                        : "กรมธรรม์ประกันชีวิต"}
                    </div>
                    {policyDataLoading
                      ? // Show skeleton loaders when data is loading
                        Array(3)
                          .fill()
                          .map((_, idx) => (
                            <div
                              key={idx}
                              style={{
                                marginBottom: "10px",
                                display: "flex",
                                alignItems: "flex-start",
                              }}
                            >
                              <Skeleton
                                width={20}
                                height={20}
                                style={{
                                  marginRight: "10px",
                                  marginTop: "5px",
                                }}
                              />
                              <div style={{ width: "100%" }}>
                                <Skeleton
                                  width="80%"
                                  height={20}
                                  style={{ marginBottom: "5px" }}
                                />
                                <Skeleton width="60%" height={20} />
                              </div>
                            </div>
                          ))
                      : // Show actual checkboxes when data is loaded
                        filteredDataRdConsent.map((item, idx) => (
                          <div
                            key={idx}
                            style={{
                              marginBottom: "10px",
                              display: "flex",
                              alignItems: "flex-start",
                            }}
                          >
                            <input
                              type="checkbox"
                              id={`policy_consent_step0_${idx}`}
                              name="policy_consent_step0"
                              // ใช้ค่าเริ่มต้นจาก LS > API
                              checked={!!checkedPolicies[idx]}
                              onChange={(e) =>
                                onTogglePolicy(e.target.checked, item, idx)
                              }
                              // คง process เดิม ให้ clickPolicy ทำงาน แต่ส่งสถานะปัจจุบันเข้าไป
                              // onClick={(e) =>
                              //   clickPolicy(item.policyNo, e.target.checked)
                              // }
                              style={{
                                marginRight: "10px",
                                marginTop: "5px",
                                width: "20px",
                                height: "20px",
                                accentColor: "#f2654e",
                              }}
                            />

                            <div>
                              <div>กรมธรรม์เลขที่ : {item.policyNo}</div>
                              <div>
                                ชื่อแบบประกัน : {item.baseName || "ฮีโร่ 10/3"}
                              </div>
                            </div>
                          </div>
                        ))}
                  </div>
                )}
                <br />
                <br />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column", // จอเล็กสุด → หมายเหตุอยู่บรรทัดบน
                      sm: "column", // จอเล็ก → ยังแนวตั้ง
                      md: "row", // จอกลางขึ้นไป → หมายเหตุ | ข้อความ อยู่บรรทัดเดียว
                      lg: "row",
                      xl: "row",
                    },
                    gap: 2,
                  }}
                >
                  <Typography className="text-desc bold">หมายเหตุ</Typography>

                  <Box className="text-desc bold">
                    <Typography
                      className="text-desc bold"
                      sx={{ display: "block", mb: 1 }}
                    >
                      * การไม่แจ้งความประสงค์ที่จะใช้สิทธิยกเว้นภาษีเงินได้
                      ต่อบริษัทอาจทำให้ท่านไม่สามารถหักค่าลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับเบี้ยประกันภัย
                      ตามข้อกำหนดของกรมสรรพากรได้
                    </Typography>

                    <Typography
                      className="text-desc bold"
                      sx={{ display: "block" }}
                    >
                      ** ตามประกาศอธิบดีกรมสรรพากรเกี่ยวกับภาษีเงินได้ ( ฉบับที่
                      383 )
                      กำหนดให้ผู้มีเงินได้ที่ต้องการนำเบี้ยประกันไปใช้สิทธิลดหย่อนภาษีเงินได้สำหรับปีภาษี
                      2561 เป็นต้นไป ต้องแจ้งความประสงค์ที่จะใช้สิทธิ
                      และจะยินยอมให้บริษัทฯ
                      เปิดเผยข้อมูลเกี่ยวกับเบี้ยประกันภัยต่อกรมสรรพากร
                      ภายในวันที่ 31 ธันวาคม ของปีภาษีนั้น ๆ
                    </Typography>
                  </Box>
                </Box>
              </div>
            </div>
          )}

          {activeStep === 1 && (
            <div style={{ padding: "20px", margin: "0 45px 20px 45px" }}>
              <div
                style={{
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "start",
                  width: "100%",
                }}
              >
                OTP
              </div>
              <TextField
                InputProps={{
                  sx: {
                    marginTop: 2,
                    borderRadius: 16,
                    borderColor: "#fdcfc7",
                  },
                }}
                id="otp_input"
                type="search"
                placeholder="OTP"
                variant="outlined"
                size="small"
                fullWidth
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                inputProps={{
                  maxLength: 6,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  },
                }}
              />

              {otpError && (
                <div
                  className="font-size-content-otp"
                  style={{
                    marginLeft: 10,
                    marginTop: 5,
                    color: "red",
                  }}
                >
                  {otpError}
                </div>
              )}

              <div
                style={{
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: "flex-start",
                  width: "100%",
                  marginTop: 10,
                }}
              >
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px" }}
                >
                  ส่งรหัสผ่านไปที่หมายเลข{" "}
                  {localStorage.getItem("mobile_tel")
                    ? localStorage
                        .getItem("mobile_tel")
                        .replace(/(\d{3})(\d{4})(\d{3})/, "$1xxxx$3")
                    : ""}
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px" }}
                >
                  {" "}
                  กรณีไม่ได้รับหรือเปลี่ยนหมายเลขโทรศัพท์มือถือ
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px" }}
                >
                  กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ 026483600
                </div>
              </div>

              <Typography
                style={{ color: "#f2654e", cursor: "pointer" }}
                onClick={resendOtp}
              >
                ส่งรหัส OTP อีกครั้ง?
              </Typography>
            </div>
          )}
          <></>

          <>
            {activeStep === 1 &&
              dataRdConsent.some((item) =>
                dataPolicies.some(
                  (policy) =>
                    item.policyNo === policy.policyNo &&
                    item.consentFlag === "Y"
                )
              )}
          </>

          {/* <div className="d-flex justify-content-center flex-wrap"> */}
          <section className="action-address">
            <Grid
              container
              item
              xs={12}
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={6} md={2}>
                <button
                  onClick={goToHome}
                  className="btn-address-back w-100 p-2 bold"
                  style={{ minWidth: "100px", fontSize: "15px" }}
                >
                  {activeStep === 0 ? "ย้อนกลับ" : "กลับ"}
                </button>
              </Grid>
              <Grid item xs={6} md={2}>
                <button
                  disabled={!consentOption}
                  onClick={handleConfirm}
                  className="btn-address-next w-100 p-2 bold"
                >
                  {activeStep === 0
                    ? "ต่อไป"
                    : activeStep === 1
                    ? "ตกลง"
                    : "ยืนยัน"}
                </button>
              </Grid>
            </Grid>
          </section>
          <br />
        </div>
      ) : (
        <>
          <div
            className="p-4 frame-other"
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "20px auto 0 auto",
              maxWidth: "1600px",
            }}
          >
            <Typography variant="h3" align="center">
              <img
                src={successGif}
                alt={"confirmGif"}
                style={{
                  height: "auto",
                  marginTop: "5%",
                  marginBottom: "5%",
                  width: "20%",
                }}
              />
              <li
                className="body-list-group"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Col
                  xl={12}
                  md={12}
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <h3 className="bold">บันทึกข้อมูลสำเร็จ</h3>
                </Col>
              </li>
            </Typography>
            <Row className="d-flex  flex-column mb-5">
              <Col className="d-flex justify-content-center px-5">
                <button
                  style={{
                    backgroundcolor: "#f2654e!important",
                    cursor: "pointer",
                  }}
                  onClick={goToHome}
                  type="button"
                  className="btn-address-next w-25 p-2 bold"
                >
                  กลับสู่หน้าหลัก
                </button>
              </Col>
            </Row>
          </div>
        </>
        // <SuccessPage />
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header></Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          กรุณาเลือกกรมธรรม์ที่ต้องการทำรายการ !!!
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <a
            onClick={() => setShowModal(false)}
            type="button"
            className="mt-3 btn-back"
            style={{ minWidth: "100px", textAlign: "center" }}
          >
            Close
          </a>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header></Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          ท่านยืนยันข้อมูลหรือไม่
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <a
            onClick={() => setShowConfirmModal(false)}
            type="button"
            className="mt-3 btn-back"
            style={{ minWidth: "100px", textAlign: "center", fontSize: "15px" }}
          >
            ยกเลิก
          </a>
          <a
            onClick={() => saveData()}
            type="button"
            className="mt-3 btn-confirm"
            style={{ minWidth: "100px", textAlign: "center", fontSize: "15px" }}
          >
            บันทึก
          </a>
        </Modal.Footer>
      </Modal>
      <Modal show={otpAlertOpen} backdrop="static" size="md" centered>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={remove}
              alt={"errorIcon"}
              style={{
                height: "auto",
                width: "20%",
              }}
            />
          </div>

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                marginTop: 20,
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <h3 className="font-size-content-alert-modal">{otpAlertText}</h3>
            </Col>
          </li>
          <div className="App">
            <div className="d-flex justify-content-center flex-wrap">
              <button
                className="btn-back"
                onClick={() => {
                  setOtpAlertOpen(false);
                  setActiveStep(0);
                }}
              >
                กลับ
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* OTP Sent Modal */}
      <Modal show={otpSentModalOpen} backdrop="static" size="md" centered>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={info}
              alt={"infoIcon"}
              style={{
                height: "auto",
                width: "20%",
              }}
            />
          </div>

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                marginTop: 20,
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <h3 className="font-size-content-alert-modal">
                {otpSentMessage}
              </h3>
            </Col>
          </li>
          <div className="App">
            <div className="d-flex justify-content-center flex-wrap">
              <button
                className="btn-checkout-back-modal w-30 p-2 bold"
                onClick={() => saveData()}
              >
                ตกลง
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ExemptIncomeTax;
